import { ReactElement, useRef, useState, cloneElement } from 'react'
import { classNames } from '@/lib/misc/Utils'
import { useOnClickOutside } from '@/lib/hooks/useOnClickOutside'

export const DropdownContent = ({
  children,
  content,
  className,
  onClose,
  isOpen,
  onToggle,
}: {
  children: ReactElement
  content: ReactElement
  className?: string
  onClose?: () => void
  isOpen?: boolean
  onToggle?: () => void
}) => {
  const ref = useRef(null)
  const [internalToggled, setInternalToggle] = useState(false)

  const toggled = isOpen !== undefined ? isOpen : internalToggled
  const setToggle = onToggle !== undefined ? onToggle : setInternalToggle

  useOnClickOutside(ref, () => {
    if (isOpen !== undefined && onToggle) {
      onToggle()
    } else {
      setInternalToggle(false)
    }
    onClose?.()
  })

  return (
    <div className="relative" ref={ref}>
      <span
        onClick={() => setToggle(!toggled)}
        className="relative flex justify-center h-full"
      >
        {children}
      </span>

      {toggled && (
        <div className={classNames('absolute z-60 right-0 top-11', className)}>
          {cloneElement(content, { onClose } as Record<string, unknown>)}
        </div>
      )}
    </div>
  )
}
